export const domains = [
	{
		key: 'spa.themedspa.store',
		label: 'spa.themedspa.store',
		value: 'spa.themedspa.store'
	}, {
		key: 'bestwaytoloseweight.com',
		label: 'bestwaytoloseweight.com',
		value: 'bestwaytoloseweight.com'
	},
	{
		key: 'hipdips.co',
		label: 'hipdips.co',
		value: 'hipdips.co'
	},
	{
		key: 'boardandkayak.com',
		label: 'boardandkayak.com',
		value: 'boardandkayak.com'
	},
	{
		key: 'finehomegardening.com',
		label: 'finehomegardening.com',
		value: 'finehomegardening.com'
	},
	{
		key: 'foolsavenue.com',
		label: 'foolsavenue.com',
		value: 'foolsavenue.com'
	},
	{
		key: 'highestrated.us',
		label: 'highestrated.us',
		value: 'highestrated.us'
	},
	{
		key: 'theseohacker.com',
		label: 'theseohacker.com',
		value: 'theseohacker.com'
	},
	{
		key: 'convention-housing.com',
		label: 'convention-housing.com',
		value: 'convention-housing.com'
	},
	{
		key: 'rooms.buzz',
		label: 'rooms.buzz',
		value: 'rooms.buzz'
	},
	{
		key: 'quotation.one',
		label: 'quotation.one',
		value: 'quotation.one'
	},
	{
		key: 'events.guru',
		label: 'events.guru',
		value: 'events.guru'
	},
	{
		key: 'local',
		label: 'local',
		value: 'local'
	}
];
